import * as React from "react";
const Cloud = (props) => (
  <svg
    width={115}
    height={115}
    viewBox="0 0 115 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M52.708 86.2693H31.8978C19.5736 86.2501 9.58301 76.6332 9.58301 64.7691C9.58301 52.9049 19.5736 43.2928 31.8978 43.2928C33.7809 34.8499 40.494 27.9595 49.5072 25.2138C58.5155 22.473 68.463 24.2891 75.593 30.0055C82.723 35.7076 85.9526 44.4141 84.0742 52.857H88.818C92.3626 52.865 95.8119 54.0056 98.6626 56.1123C101.513 58.219 103.616 61.1817 104.664 64.5678M95.833 100.625L105.416 91.0418L95.833 81.4584M81.458 81.4584L71.8747 91.0418L81.458 100.625"
      stroke="white"
      strokeWidth={8.58}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Cloud;
